import React from 'react';
import { useNavigate } from 'react-router-dom';

export const PoliciesIndexPage: React.FC = () => {
  const navigate = useNavigate();

  const policies = [
    {
      title: 'Terms of Use',
      path: '/policies/terms-of-use',
      description: 'Review the terms and conditions governing your use of ChatHTL services.'
    },
    {
      title: 'Privacy Policy',
      path: '/policies/privacy-policy',
      description: 'Learn how we collect, use, and protect your personal information.'
    },
    {
      title: 'Data Processing Addendum',
      path: '/policies/data-processing-addendum',
      description: 'Understand our commitment to GDPR compliance and data processing practices.'
    },
    {
      title: 'SMS Opt-In Policy',
      path: '/policies/sms-opt-in',
      description: 'Review our SMS messaging practices, consent requirements, and how to opt out.'
    }
  ];

  return (
    <div className="min-h-screen bg-neutral-white dark:bg-neutral-black">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-neutral-black dark:text-neutral-white mb-4">
            Terms & Policies
          </h1>
          <p className="text-lg text-neutral-medium-gray dark:text-neutral-medium-gray">
            Review our legal policies and terms governing your use of ChatHTL
          </p>
        </div>

        {/* Policy Cards */}
        <div className="space-y-4">
          {policies.map((policy) => (
            <div
              key={policy.path}
              onClick={() => navigate(policy.path)}
              className="bg-white dark:bg-neutral-dark-gray border border-neutral-light-gray dark:border-neutral-dark-gray rounded-lg p-6 hover:shadow-md transition-shadow cursor-pointer"
            >
              <h2 className="text-xl font-semibold text-neutral-black dark:text-neutral-white mb-2">
                {policy.title}
              </h2>
              <p className="text-neutral-medium-gray dark:text-neutral-medium-gray">
                {policy.description}
              </p>
              <div className="mt-4 flex items-center text-brand-teal hover:text-brand-teal-hover">
                <span className="text-sm font-medium">Read Policy</span>
                <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </div>
            </div>
          ))}
        </div>

        {/* Back to Chat */}
        <div className="mt-8">
          <button
            onClick={() => navigate('/')}
            className="text-brand-teal hover:text-brand-teal-hover flex items-center"
          >
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back to Chat
          </button>
        </div>
      </div>
    </div>
  );
};
